import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FetchCaseBrandModel, CaseStudyBrandModel } from '../models/case_study';
import Screenshot from './Screenshot';

export const Block = () => {
  const caseStudies = useSelector((state: FetchCaseBrandModel) => state);
  const [screenshotArr, setscreenshotArr] = useState<Array<string>>([]);

  const handleShowScreenshots = (imgListLink: string) => {
    const imgLinkArr = imgListLink.split(",") as string[];
    setscreenshotArr(imgLinkArr)
  }

  const singleBlock = (el: CaseStudyBrandModel, index: number) => {
    return (
      <div className={`block`} key={`${index}`}>
        <a className="block-link-cs" href={`${el.website_url}`} target="_blank" rel="noopener noreferrer">
          <div className="img">
            <img src={el.brand_image_url} alt="1" />
          </div>
          <hr />
          <figcaption className="content">
            <p className="title">
              {el.brand}
            </p>
            <p className="sub-content">
              {el.campaign}
            </p>
          </figcaption>
        </a>
        <div className="buttons">
          <div className="button btn-case-study">
            <a className="btn-link-cs" href={`${el.website_url}`} target="_blank" rel="noopener noreferrer">
              <img className="img-cs" src="https://yoose.com/hubfs/y-case-study/assets/images/case-study.png" alt="case_study_img" />
              <p className="btn-name-cs">Case Study</p>
            </a>
          </div>
          {(el.link_screenshot !== undefined) ?
            <div className="button btn-screen-shot" onClick={() => handleShowScreenshots(el.link_screenshot)}>
              <img className="img-screen" src="https://yoose.com/hubfs/y-case-study/assets/images/screenshot.png" alt="screenshot_img" />
              <p className="btn-name-screen">Screenshot</p>
            </div> : null
          }
        </div>
      </div>
    )
  }

  const filterArrCaseStudy = (arr: any[]) => {
    return arr.filter((item: any) => parseFloat(item.case_study_name.slice(-4)) > 2018)
  }

  const showListCs = () => {
    console.log({ caseStudies: filterArrCaseStudy(caseStudies.case_study) });
    let data_cs = (caseStudies.is_filter_list.length === 0) ? filterArrCaseStudy(caseStudies.case_study) : filterArrCaseStudy(caseStudies.is_filter_list)
    return data_cs.map((csEl, index) => {
      return singleBlock(csEl, index);
    })
  }

  return (
    <div className="blocks">
      {
        showListCs()
      }
      <Screenshot listImgLink={screenshotArr} />
    </div>
  )
}

